import * as actionTypes from "./actionTypes";
import API from "../../axios/api";
import axios from "axios";
import filterObjectToQuery from '../../utils/filterObjectToQuery';

let CancelToken = axios.CancelToken;
let fetchEmailLogs_cancel;
let fetchEmailLogsById_cancel;
let fetchEmailLogsOptionsTenants_cancel

export const requestEmailLogsStart = () => {
  return {
    type: actionTypes.REQUEST_EMAIL_LOGS_START,
  };
};

export const fetchEmailLogsSuccess = (logs) => {
  return {
    type: actionTypes.FETCH_EMAIL_LOGS_SUCCESS,
    logs,
  };
};

export const requestEmailLogByIdStart = () => {
  return {
    type: actionTypes.REQUEST_EMAIL_LOG_BY_ID_START,
  };
};

export const fetchEmailLogsByIdSuccess = (emailLog) => {
  return {
    type: actionTypes.FETCH_EMAIL_LOG_BY_ID_SUCCESS,
    emailLog,
  };
};

export const setEmailLogsFilter = (page, limit, search, order, orderBy, startDate, endDate, filteredEmailTypes, filteredTenants) => {
  return {
    type: actionTypes.SET_EMAIL_LOGS_FILTER,
    emailLogsFilter: {
      page,
      limit,
      search,
      order,
      orderBy,
      startDate,
      endDate,
      filteredEmailTypes,
      filteredTenants
    },
  };
};

export const clearEmailLogsFilter = (page, limit, search, order, orderBy) => {
  return dispatch => {
    dispatch(fetchEmailLogs(page, limit, search, order, orderBy, null, null, [], []));
  }
}

export const requestEmailLogsOptionsTenantsStart = () => {
  return {
    type: actionTypes.REQUEST_EMAIL_LOGS_OPTIONS_TENANTS_START,
  };
};

export const fetchEmailLogsOptionsTenantsSuccess = (tenants) => {
  return {
    type: actionTypes.FETCH_EMAIL_LOGS_OPTIONS_TENANTS_SUCCESS,
    tenants,
  };
};

export const fetchEmailLogsOptionsTenantsFail = (error) => {
  return {
    type: actionTypes.FETCH_EMAIL_LOGS_OPTIONS_TENANTS_FAIL,
    error,
  };
};

export const triggerRemoveEmailLogsStartDateFilter = (page, limit, search, order, orderBy, filteredEndDate, selectedEmailTypes, filteredTenants) => {
  return dispatch => {
    dispatch(fetchEmailLogs(page, limit, search, order, orderBy, null, filteredEndDate, selectedEmailTypes, filteredTenants))
  }
};

export const triggerRemoveEmailLogsEndDateFilter = (page, limit, search, order, orderBy, filteredStartDate, selectedEmailTypes, filteredTenants) => {
  return dispatch => {
    dispatch(fetchEmailLogs(page, limit, search, order, orderBy, filteredStartDate, null, selectedEmailTypes, filteredTenants))
  }
};

export const triggerRemoveEmailLogsEmailTypesFilter = (page, limit, search, order, orderBy, filteredStartDate, filteredEndDate, selectedEmailTypes, filteredTenants, emailType) => {
  return dispatch => {
    let aux = [...selectedEmailTypes];
    const newFilteredEmailTypes = aux.filter((el) => el.value !== emailType.value);
    dispatch(fetchEmailLogs(page, limit, search, order, orderBy, filteredStartDate, filteredEndDate, newFilteredEmailTypes, filteredTenants));
  }
};

export const triggerRemoveEmailLogsTenantsFilter = (page, limit, search, order, orderBy, filteredStartDate, filteredEndDate, selectedEmailTypes, filteredTenants, docId) => {
  return dispatch => {
    let aux = [...filteredTenants];
    const newFilteredTenants = aux.filter((el) => el !== docId);
    dispatch(fetchEmailLogs(page, limit, search, order, orderBy, filteredStartDate, filteredEndDate, selectedEmailTypes, newFilteredTenants));
  }
};

export const fetchEmailLogsOptionsTenants = (page = 1, limit = 10, search, order = 'asc', orderBy = 'name') => {
  fetchEmailLogsOptionsTenants_cancel && fetchEmailLogsOptionsTenants_cancel()
  return dispatch => {
    dispatch(requestEmailLogsOptionsTenantsStart());
    const queryParams = `?page=${!page || page < 1 ? 1 : page}&limit=${!limit || limit < 5 ? 5 : limit}&q=${search ? search : ''}&sort=${order === 'desc' ? '-' : ''}${orderBy}`;
    API.get('/tenants' + queryParams, {
      cancelToken: new CancelToken(function executor(c) {
        fetchEmailLogsOptionsTenants_cancel = c;
      })
    })
      .then(res => {
        dispatch(fetchEmailLogsOptionsTenantsSuccess(res.data));
      })
      .catch(err => {
        dispatch(fetchEmailLogsOptionsTenantsFail(err));
      });
  };
};

export const fetchEmailLogs = (
  page, limit, search, order, orderBy, startDate, endDate, filteredEmailTypes, filteredTenants
) => {
  fetchEmailLogs_cancel && fetchEmailLogs_cancel();
  return (dispatch) => {
    dispatch(setEmailLogsFilter(page, limit, search, order, orderBy, startDate, endDate, filteredEmailTypes, filteredTenants));
    dispatch(requestEmailLogsStart());
    let queryParams = `?page=${!page || page < 1 ? 1 : page}&limit=${
      !limit || limit < 25 ? limit : limit
    }&q=${search ? search : ''}&sort=${order === "desc" ? "-" : ""}${orderBy}`;
    queryParams += `${startDate ? `&start_date=${startDate.toISOString()}` : ''}`;
    queryParams += `${endDate  ? `&end_date=${endDate.toISOString()}` : ''}`;
    queryParams += `${filteredEmailTypes && filteredEmailTypes.length > 0 ? `&emailTypes=${filterObjectToQuery(filteredEmailTypes)}` : ''}`;
    queryParams += `${filteredTenants && filteredTenants.length > 0 ? `&tenants=${filterObjectToQuery(filteredTenants)}` : ''}`;

    API.get("/sentemails" + queryParams, {
      cancelToken: new CancelToken(function executor(c) {
        fetchEmailLogs_cancel = c;
      }),
    }).then((res) => {
      dispatch(fetchEmailLogsSuccess(res.data));
    }).catch((err) => console.error(err));
  };
};

export const fetchEmailLogsById = (id) => {
  fetchEmailLogsById_cancel && fetchEmailLogsById_cancel();

  return (dispatch) => {
    dispatch(requestEmailLogByIdStart());
    API.get("/sentemails/" + id, {
      cancelToken: new CancelToken(function executor(c) {
        fetchEmailLogsById_cancel = c;
      }),
    })
      .then((res) => {
        dispatch(fetchEmailLogsByIdSuccess(res.data));
      })
      .catch((err) => {
        console.log(err);
      });
  };
};